<template>
  <QuizJoinGameForm v-if="isShowFormJoinGame" class="padding spinner-wheel_form-join-game" />

  <div
    class="text-center padding"
    :class="{'white': slide.textColour == '#ffffff'}"
    v-else
  >
    <div v-if="slide.title || slide.titleDesc">
      <h2
        class="mt-0 title slide-title-style"
        v-html="dataValue"
      />
      <p
        class="custom-mb-3 subheading word-pre"
        :inner-html.prop="slide.titleDesc | sanitize(true)"
      />
    </div>

    <SpinnerWheelWaiting v-if="showWaitingSpinnerWheel()" />

    <SpinnerWheelResult v-else />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import SpinnerWheelWaiting from '@/components/types/spinner-wheel/SpinnerWheelWaiting.vue'
import QuizJoinGameForm from '@/components/QuizJoinGameForm.vue'
import SpinnerWheelResult from '@/components/types/spinner-wheel/SpinnerWheelResult.vue'
import ClickableTitleMixin from '@/mixins/ClickableTitleMixin'

export default {
  components: {
    SpinnerWheelWaiting,
    QuizJoinGameForm,
    SpinnerWheelResult,
  },
  mixins: [ClickableTitleMixin],
  props: {
    isShowFormJoinGame: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      slide: 'activeActivity',
    }),
  },
  methods: {
    showWaitingSpinnerWheel() {
      if (!this.slide.metadata) return true
      if (!this.slide.metadata.wheelStatus || this.slide.metadata.wheelStatus === 'spinning') return true
      if (!this.slide.metadata.winner) return true
      return false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.text-center {
  text-align: center;
}

.padding {
  padding: 0 16px;
}

.title {
  font-weight: bold;
  font-size: 28px;
  margin-bottom: 0;
}
.audio-control-slide {
  margin-top: 18px;
}

.spinner-wheel_waiting {
  max-width: 390px;
  position: relative;
  margin: 0 auto;
  margin-bottom: 60px;
  overflow: hidden;
}

.spinner-wheel_wheel {
  width: 100%;
  animation: spin 15s linear infinite;
}

.spinner-wheel_pointer {
  position: absolute;
  top: 5px;
  left: 55px;
  z-index: 1;
}

.spinner-wheel_box {
  background: #FFFFFF;
  box-shadow: 0px 5.5142px 5.5142px rgba(0, 0, 0, 0.05);
  border-radius: 14px;
  color: #333;
  text-align: center;
  position: absolute;
  top: 50%;
  width: 100%;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: bold;
  line-height: 1.4;
  transform: translateY(-50%);
}

.spinner-wheel_form-join-game {
  margin-bottom: 16px;
}

.word-pre {
  word-wrap: break-word;
}
</style>
